module.exports = __webpack_public_path__ + "static/laptop-67897f7cde1fd9711681aa5bd7fafa5c.svg";